import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navigation } from '../Navigation';
import { SideNav } from './SideNav';

/**
 * App chrome: top bar across the full width, collapsible page rail on the
 * left, routed content on the right.
 *
 * Pages rendered inside the Outlet must NOT render <Navigation /> themselves —
 * the shell owns it now.
 */
export const AppShell: React.FC = () => (
  <div className="h-screen flex flex-col bg-dark-bg overflow-hidden">
    <Navigation />
    <div className="flex-1 flex min-h-0">
      <SideNav />
      {/* min-w-0 stops wide widget grids from forcing the rail to shrink */}
      <main className="flex-1 min-w-0 flex flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  </div>
);
